//import * as Raven from 'raven-js';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule, ErrorHandler} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CookieService} from 'ngx-cookie-service';
import { APP_BASE_HREF, Location } from '@angular/common';

import {AppComponent} from './app.component';
import {AppErrorHandler} from './app-error-handler';
import {AppErrorComponent} from './app-error/app-error.component';
import {SurveyComponent} from './survey/survey.component';
import {MessagesComponent} from './messages/messages.component';
import {QuestionComponent} from './question/question.component';
import {MessageService} from './message.service';
import {ApiService} from './api.service';
import {CommonService} from './common.service';
import {TokenService} from './tokenService.service';
import {AppRoutingModule} from './app-routing.module';
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BeginComponent} from './begin/begin.component';
import {CountdownComponent} from './countdown/countdown.component';
import {FailComponent} from './fail/fail.component';
import {ReportComponent} from './report/report.component';

import {RadarComponent} from './radar/radar.component';
import {AngularEchartsModule} from 'ngx-echarts';
import {CharacterComponent} from './character.component';
import {LearningPathComponent} from './learning-path/learning-path.component';
import {CasePracticeComponent} from './case-practice.component';
import {CasePracticeBeginComponent} from './case-practice-begin/case-practice-begin.component';
import {CasePracticeMainComponent} from './case-practice-main/case-practice-main.component';
import {LeaderTalkComponent} from './leader-talk/leader-talk.component';
import {StaffTalkComponent} from './staff-talk/staff-talk.component';
import {ExpertHintsComponent} from './expert-hints/expert-hints.component';
import {SmallGuideComponent} from './small-guide/small-guide.component';
import {BigGuideComponent} from './big-guide/big-guide.component';
import {SceneTextComponent} from './scene-text/scene-text.component';
import {CasePracticeReportSmallComponent} from './case-practice-report-small/case-practice-report-small.component';
import {CasePracticeReportBigComponent} from './case-practice-report-big/case-practice-report-big.component';
import {ReportListButtonComponent} from './report-list-button/report-list-button.component';
import {SlideButtonComponent} from './slide-button/slide-button.component';
import {CourseLearningComponent} from './course-learning.component';
import {CourseLearningHomePageComponent} from './course-learning-home-page/course-learning-home-page.component';
import {CourseLearningMainComponent} from './course-learning-main/course-learning-main.component';
import {PracticeReportComponent} from './practice-report.component';
import {ActivityComponent} from './activity.component';
import {ActivityReportComponent} from './activity-report/activity-report.component';
import {ActivityIntroductionComponent} from './activity-introduction/activity-introduction.component';
import {ActivitySuccessComponent} from './activity-success/activity-success.component';
import {ActivityFormComponent} from './activity-form/activity-form.component';
import {AbilityTestReportComponent} from './ability-test-report/ability-test-report.component';
import {HrReportComponent} from './hr-report.component';
import {HrReportOverviewComponent} from './hr-report-overview/hr-report-overview.component';
import {GraduationComponent} from './graduation/graduation.component';
import {PostAbilityTestTipComponent} from './post-ability-test-tip/post-ability-test-tip.component';
import {CourseLearningQuestionComponent} from './course-learning-question/course-learning-question.component';
import {CourseLearningHomeComponent} from './course-learning-home/course-learning-home.component';
import {LearningMapIntroductionComponent} from './learning-map-introduction/learning-map-introduction.component';
import {LearningPathNewComponent} from './learning-path-new.component';
import {LearningMapWrapComponent} from './learning-map-wrap.component';
import {VectorComponent} from './vector.component';
import {CasePracticeTeamComponent} from './case-practice-team/case-practice-team.component';
import {CasePracticeTeamListComponent} from './case-practice-team-list/case-practice-team-list.component';
import {CasePracticeTeamVideoComponent} from './case-practice-team-video/case-practice-team-video.component';
import {CasePracticeTeamQuestionComponent} from './case-practice-team-question/case-practice-team-question.component';
import {CasePracticeTeamMainComponent} from './case-practice-team-main/case-practice-team-main.component';
import {CasePracticeTeamBeginComponent} from './case-practice-team-begin/case-practice-team-begin.component';
import {CasePracticeTeamReportComponent} from './case-practice-team-report/case-practice-team-report.component';
import {CasePracticeListComponent} from './case-practice-list/case-practice-list.component';
import {CasePracticeReportNewComponent} from './case-practice-report-new/case-practice-report-new.component';
import {CasePracticeAuthorizationComponent} from './case-practice-authorization/case-practice-authorization.component';
import {CasePracticeAuthorizationListComponent} from './case-practice-authorization-list/case-practice-authorization-list.component';
import {CasePracticeAuthorizationVideoComponent} from './case-practice-authorization-video/case-practice-authorization-video.component';
import {CasePracticeAuthorizationChoiceComponent} from './case-practice-authorization-choice/case-practice-authorization-choice.component';
import {CasePracticeAuthorizationQuestionComponent} from './case-practice-authorization-question/case-practice-authorization-question.component';
import {CasePracticeAuthorizationMainComponent} from './case-practice-authorization-main/case-practice-authorization-main.component';
import {CasePracticeAuthorizationReportComponent} from './case-practice-authorization-report/case-practice-authorization-report.component';
import {CasePracticeAuthorizationBeginComponent} from './case-practice-authorization-begin/case-practice-authorization-begin.component';
import { CasePracticePAndOComponent } from './case-practice-p-and-o/case-practice-p-and-o.component';
import { CasePracticePAndOReportComponent } from './case-practice-p-and-o-report/case-practice-p-and-o-report.component';
import { CasePracticePAndOPreviousComponent } from './case-practice-p-and-o-previous/case-practice-p-and-o-previous.component';
import { CasePracticePAndOCalculationComponent } from './case-practice-p-and-o-calculation/case-practice-p-and-o-calculation.component';
import { CasePracticePAndODialogueComponent } from './case-practice-p-and-o-dialogue/case-practice-p-and-o-dialogue.component';
import { CasePracticePAndOListComponent } from './case-practice-p-and-o-list/case-practice-p-and-o-list.component';
import { CasePracticePAndOEventComponent } from './case-practice-p-and-o-event/case-practice-p-and-o-event.component';
import { CasePracticeCooperationComponent } from './case-practice-cooperation/case-practice-cooperation.component';
import { CasePracticeCooperationListComponent } from './case-practice-cooperation-list/case-practice-cooperation-list.component';
import { CasePracticeCooperationBeginComponent } from './case-practice-cooperation-begin/case-practice-cooperation-begin.component';
import { CasePracticeCooperationQuestionComponent } from './case-practice-cooperation-question/case-practice-cooperation-question.component';
import { CasePracticeCooperationVideoComponent } from './case-practice-cooperation-video/case-practice-cooperation-video.component';
import { GraduationNewComponent } from './graduation-new/graduation-new.component';
import { CasePracticeInfluenceComponent } from './case-practice-influence/case-practice-influence.component';
import { CasePracticeInfluenceListComponent } from './case-practice-influence-list/case-practice-influence-list.component';
import { CasePracticeInfluenceBeginComponent } from './case-practice-influence-begin/case-practice-influence-begin.component';
import { CasePracticeInfluenceMainComponent } from './case-practice-influence-main/case-practice-influence-main.component';
import { CasePracticeNavComponent } from './case-practice-nav/case-practice-nav.component';
import { CasePracticeHotelComponent } from './case-practice-hotel/case-practice-hotel.component';
import { CasePracticeMessageboxComponent} from "./case-practice-hotel/case-practice-hotel-component/case-practice-messagebox.component";
import { CasePracticeReportNew2Component} from "./case-practice-report-new-2/case-practice-report-new-2.component";
import { ReportLevelExplainComponent} from './report-level-explain/report-level-explain.component';
import { AbilitySurveyComponent } from './ability-survey/ability-survey.component';
import { CampLeadershipSurveyComponent } from './learning-camp/camp-leadership-survey/camp-leadership-survey.component';
import { AbilityReportComponent } from './ability-report/ability-report.component';
import { AppComTipComponent } from './app-com-tip/app-com-tip.component';
import { AppAudioPlayComponent } from './app-audio-play/app-audio-play.component';
import { ValidateFormComponent } from './validate-form/validate-form.component';
import {CasePracticeRevolutionReportComponent} from "./case-practice-revolution-report/case-practice-revolution-report.component";
import {CasePracticePerformanceReportComponent} from './case-practice-performance-report/case-practice-performance-report.component';
import {LearningMapOpenClassComponent} from './learning-map-open-class.component';
import {AppAudioPlayBaseComponent} from './app-audio-play-base/app-audio-play-base.component';
import {ComponentScrollTitleComponent} from './scroll-title/component.scroll-title';
import {LoadingComponent} from './loading/loading.component';
import {LearningMapNothingComponent} from './learning-map-nothing.component';
import {WebLoginComponent} from './web-login/web-login.component';
import {CasePracticeClashReportComponent} from './case-practice-clash-report/case-practice-clash-report.component';
import {CasePracticeCoachComponent} from './case-practice-coach/case-practice-coach.component';
import {AbilityReportNewComponent} from './ability-report-new/ability-report-new.component';
import {CampLeadershipReportComponent} from './learning-camp/camp-leadership-report/camp-leadership-report.component';
import {AppChartsComponent} from './app-charts/app-charts.component';
import {AppHeartBeatComponent} from './app-heart-beat/app-heart-beat.component';
import {AppHeartBeatService} from './app-heart-beat/app-heart-beat.service';
import { StoreService } from './store.service'

import {NewAppLoginComponent} from './new-app-login/new-app-login.component';
import {ForceChangePasswordComponent} from './force-change-password/force-change-password.component';
import {LaunchpageComponent} from './launchpage.component';
import {ScormCourseComponent} from './scorm-course.component';
import { CourseSelectComponent } from './course-select/course-select.component';
import { CourseLearningHomeNoteComponent} from './course-learning-home/course-learning-home-note.component';

//UI components and pipes begin here
import {SharedUIModule} from '../component-ui'
import { AppPipesModule } from '../pipes/index.module';
import { UserAvailableAskingComponent } from './user-available-asking/user-available-asking.component'
import {CasePracticeInfluenceProListComponent} from './case-practice-influence-pro-list/case-practice-influence-pro-list.component';
import {CasePracticeInfluenceProBeginComponent} from './case-practice-influence-pro-begin/case-practice-influence-pro-begin.component';
import {CasePracticeInfluenceProComponent} from './case-practice-influence-pro/case-practice-influence-pro.component';
import {SharedProModule} from '../component/shareProModule';
import {AppQuestionnaireComponent} from './app-questionnaire/app-questionnaire.component';
import {AppQuestionnaireModule} from './app-questionnaire/app-questionnaire.module';
import {LearningMapComponent} from './learning-map/learning-map.component';
import {AppGdprComponent} from './app-gdpr/app-gdpr.component';
import {LearningMapOldComponent} from './learning-map/learning-map-old.component';
import {CourseNewModule} from './new-course/course-new.module';
import {CasePracticeTsComponent} from './case-practice-ts/case-practice-ts.component';
import {CasePracticeTsListComponent} from './case-practice-ts-list/case-practice-ts-list.component';
import {CasePracticeTsReportComponent} from './case-practice-ts-report/case-practice-ts-report.component';
import {LearningPathIntroductionComponent} from './learning-path-introduction/learning-path-introduction.component';
import {AppShareComponent} from './app-share/app-share.component';
import {CasePracticeCommunicateListComponent} from './case-practice-communicate-list/case-practice-communicate-list.component';
import {CasePracticeCommunicateComponent} from './case-practice-communicate/case-practice-communicate.component';
import {CasePracticeCommunicateReportComponent} from './case-practice-communicate-report/case-practice-communicate-report.component';
import {LearningCampComponent} from './learning-camp/learning-camp.component';
import {LearningCampResponseComponent} from './learning-camp/camp-response/learning-camp-response.component';
import {LearningCampRequsetComponent} from './learning-camp/camp-request/learning-camp-request.component';
import {HomeWorkRequsetComponent} from './app-home-work-show/home-work-request/home-work-request.component';
import {LearningCampIntroductionComponent} from './learning-camp/camp-introduction/learning-camp-introduction.component';
import {LearningCampReportComponent} from './learning-camp/camp-report/learning-camp-report.component';
import {CasePracticeHeadComponent} from './case-practice-head/case-practice-head.component';
import {CasePracticeCoachReportComponent} from './case-practice-coach-report/case-practice-coach-report.component';
import {CasePracticeMaxReportComponent} from './case-practice-max-report/case-practice-max-report.component';
import {AppBreakPointComponent} from './app-break-point/app-break-point.component';
import {LearningProjectComponent} from './learning-project/learning-project.component';
import {LearningProjectPathComponent} from './learning-project-path/learning-project-path.component';
import {ExerciseBookComponent} from './app-exercrise-book/exercise-book.component';
import {ExerciseWorkComponent} from "./app-exercise-work/exercise-work.component";
import {SharedModule} from '../component/shareModule';
import {ExerciseWorkModule} from './app-exercise-work/exercise-work.module';
import {HomeWorkModule} from './app-home-work/home-work.module';
import {HomeWorkComponent} from "./app-home-work/home-work.component";
import {HomeWorkShowModule} from './app-home-work-show/home-work-show.module';
import {HomeWorkShowComponent} from "./app-home-work-show/home-work-show.component";
import {LearningCampRseponseModule} from "./learning-camp/camp-response/learning-camp-response.module"
import {AppToolsComponent} from './app-tools/app-tools.component';
import {AppAiCoachComponent} from './app-ai-coach/app-ai-coach.component';
import {AppGuideComponent} from './app-guide/app-guide.component';
import {AppMentorGuideComponent} from './app-mentor-guide/app-mentor-guide.component';
import { CampSurveyComponent } from "./learning-camp/camp-survey/camp-survey.component";
import { CampSurveyReportComponent } from "./learning-camp/camp-survey-report/camp-survey-report.component";
import {CaseExecutiveListComponent} from "./case-practice-executive-list/case-practice-executive-list.component";
import {IntelligentTransferComponent} from './intelligent-transfer/intelligent-transfer.component';
import {AppScormComponent} from './app-scorm/app-scorm.component';
//Raven
//.config('http://4a915ddd4eb84603b67ab8a127b58087@diaabie.com:9000/6')
//.install();

@NgModule({
  declarations: [
    AppComponent,
    AppErrorComponent,
    SurveyComponent,
    MessagesComponent,
    QuestionComponent,
    BeginComponent,
    CountdownComponent,
    FailComponent,
    ReportComponent,
    RadarComponent,
    CharacterComponent,
    LearningPathComponent,
    CasePracticeComponent,
    CasePracticeBeginComponent,
    CasePracticeMainComponent,
    LeaderTalkComponent,
    StaffTalkComponent,
    ExpertHintsComponent,
    SmallGuideComponent,
    BigGuideComponent,
    SceneTextComponent,
    CasePracticeReportSmallComponent,
    CasePracticeReportBigComponent,
    ReportListButtonComponent,
    SlideButtonComponent,
    CourseLearningComponent,
    CourseLearningHomePageComponent,
    CourseLearningMainComponent,
    PracticeReportComponent,
    ActivityComponent,
    ActivityReportComponent,
    ActivityIntroductionComponent,
    ActivitySuccessComponent,
    ActivityFormComponent,
    AbilityTestReportComponent,
    HrReportComponent,
    HrReportOverviewComponent,
    GraduationComponent,
    PostAbilityTestTipComponent,
    LearningMapComponent,
    LearningMapOpenClassComponent,
    LearningMapNothingComponent,
    CourseLearningQuestionComponent,
    CourseLearningHomeComponent,
    LearningMapIntroductionComponent,
    LearningPathNewComponent,
    LearningMapWrapComponent,
    VectorComponent,
    CasePracticeTeamComponent,
    CasePracticeTeamListComponent,
    CasePracticeTeamVideoComponent,
    CasePracticeTeamQuestionComponent,
    CasePracticeTeamMainComponent,
    CasePracticeTeamBeginComponent,
    CasePracticeTeamReportComponent,
    CasePracticeListComponent,
    CasePracticeReportNewComponent,
    CasePracticeAuthorizationComponent,
    CasePracticeAuthorizationListComponent,
    CasePracticeAuthorizationVideoComponent,
    CasePracticeAuthorizationChoiceComponent,
    CasePracticeAuthorizationQuestionComponent,
    CasePracticeAuthorizationMainComponent,
    CasePracticeAuthorizationReportComponent,
    CasePracticeAuthorizationBeginComponent,
    CasePracticePAndOComponent,
    CasePracticePAndOReportComponent,
    CasePracticePAndOPreviousComponent,
    CasePracticePAndOCalculationComponent,
    CasePracticePAndODialogueComponent,
    CasePracticePAndOListComponent,
    CasePracticePAndOEventComponent,
    CasePracticeCooperationComponent,
    CasePracticeCooperationListComponent,
    CasePracticeCooperationBeginComponent,
    CasePracticeCooperationQuestionComponent,
    CasePracticeCooperationVideoComponent,
    GraduationNewComponent,
    CasePracticeInfluenceComponent,
    CasePracticeInfluenceListComponent,
    CasePracticeInfluenceBeginComponent,
    CasePracticeInfluenceMainComponent,
    CasePracticeNavComponent,
    CasePracticeHotelComponent,
    CasePracticeReportNew2Component,
    CasePracticeMessageboxComponent,
    ReportLevelExplainComponent,
    AbilitySurveyComponent,
    AbilityReportComponent,
    CampLeadershipSurveyComponent,
    AbilityReportNewComponent,
    CampLeadershipReportComponent,
    AppComTipComponent,
    AppAudioPlayComponent,
    AppAudioPlayBaseComponent,
    ValidateFormComponent,
    CasePracticeRevolutionReportComponent,
    CasePracticePerformanceReportComponent,
    ComponentScrollTitleComponent,
    WebLoginComponent,
    LoadingComponent,
    CasePracticeCoachComponent,
    CasePracticeClashReportComponent,
    AppChartsComponent,
    NewAppLoginComponent,
    ForceChangePasswordComponent,
    LaunchpageComponent,
    ScormCourseComponent,
    CourseSelectComponent,
    AppHeartBeatComponent,
    UserAvailableAskingComponent,
    CasePracticeInfluenceProComponent,
    CasePracticeInfluenceProBeginComponent,
    CasePracticeInfluenceProListComponent,
    AppQuestionnaireComponent,
    CourseLearningHomeNoteComponent,
    AppGdprComponent,
    LearningMapOldComponent,
    CasePracticeTsComponent,
    CasePracticeTsListComponent,
    LearningPathIntroductionComponent,
    CasePracticeTsReportComponent,
    CasePracticeCommunicateComponent,
    CasePracticeCommunicateListComponent,
    CasePracticeCommunicateReportComponent,
    LearningCampComponent,
    LearningCampIntroductionComponent,
    LearningCampReportComponent,
    LearningCampResponseComponent,
    LearningCampRequsetComponent,
    HomeWorkRequsetComponent,
    CasePracticeHeadComponent,
    CasePracticeCoachReportComponent,
    CasePracticeMaxReportComponent,
    AppShareComponent,
    AppBreakPointComponent,
    LearningProjectComponent,
    LearningProjectPathComponent,
    ExerciseBookComponent,
    ExerciseWorkComponent,
    HomeWorkComponent,
    HomeWorkShowComponent,
    AppToolsComponent,
    AppAiCoachComponent,
    CampSurveyComponent,
    AppGuideComponent,
    AppMentorGuideComponent,
    CampSurveyReportComponent,
    CaseExecutiveListComponent,
    AppScormComponent,
    IntelligentTransferComponent
  ],
  imports: [
    BrowserModule, FormsModule, AppRoutingModule, HttpClientModule, BrowserAnimationsModule, AngularEchartsModule,
    SharedUIModule, SharedProModule, AppQuestionnaireModule, AppPipesModule.forRoot(), SharedModule, ExerciseWorkModule,HomeWorkModule,HomeWorkShowModule,LearningCampRseponseModule
  ],
  providers: [
    MessageService,
    ApiService,
    CommonService,
    TokenService,
    // {provide: ErrorHandler, useClass: AppErrorHandler},
    {provide: APP_BASE_HREF, useValue: window['_app_base'] || '/'},
    CookieService,
    AppHeartBeatService,
    StoreService],
  bootstrap: [AppComponent],
  entryComponents: [LeaderTalkComponent, StaffTalkComponent, SmallGuideComponent, BigGuideComponent, ExpertHintsComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts